import { JSX, useState } from 'react';
import { Button, useNotify } from 'react-admin';
import DownloadIcon from '@mui/icons-material/Download';
import { read_cookie } from 'sfcookies';
import { hostUrl } from '../utils/url-manager';
import { CsvImportConfig, ImportExport } from './csv-import-types';
import { downloadCsv, exportCsv } from './csv-import';

/**
 * "Export for import" for a list page's toolbar: every record in the importer's own columns, ids
 * included, so a file can be edited and loaded back with Add and update or Update only. The list's
 * own Export writes API fields, which do not import. HQ-API writes the rows (`GET` on the import
 * route), so the two cannot drift apart.
 */
export const CsvExportForImportButton = ({ config }: { config: CsvImportConfig }): JSX.Element => {
    const notify = useNotify();
    const [busy, setBusy] = useState<boolean>(false);

    async function exportRows(): Promise<void> {
        setBusy(true);
        let answer: ImportExport;
        try {
            const response: Response = await fetch(hostUrl + config.endpoint, {
                headers: { 'token': read_cookie('auth') as unknown as string },
            });
            answer = await response.json();
        } catch {
            answer = { status: 'error', message: 'HQ-API could not be reached.' };
        }
        setBusy(false);

        if (answer.status !== 'ok' || !answer.columns || !answer.rows) {
            notify(answer.message || 'The export failed.', { type: 'error' });

            return;
        }
        const date: string = new Date().toISOString().slice(0, 10);
        downloadCsv(config.fileName + '-export-' + date + '.csv', exportCsv(answer.columns, answer.rows));
    }

    return (
        <Button label={ busy ? 'Exporting...' : 'Export for import' } onClick={ exportRows } disabled={ busy }>
            <DownloadIcon />
        </Button>
    );
};
